export default {
      id: "sli-wallet-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.9328ef59.svg#sli-wallet",
      toString: function () {
        return this.url;
      }
    }